var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatusOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2C2C2C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 19.9992,
    cy: 20,
    r: 15.2941,
    fill: "#2C2C2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0205 24.5711C28.0181 23.1963 26.7164 22.08 25.219 21.3109C23.7215 20.5418 22.0696 20.141 20.3944 20.1405C18.7193 20.14 17.0671 20.5397 15.5692 21.3078C14.0713 22.076 12.7689 23.1914 11.7656 24.5655C12.7638 25.9466 14.064 27.0689 15.562 27.8423C17.0601 28.6158 18.7142 29.019 20.3917 29.0195C22.0693 29.0201 23.7236 28.618 25.2221 27.8454C26.7206 27.0729 28.0215 25.9515 29.0205 24.5711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3951 18.7199C22.693 18.7199 24.5558 16.8118 24.5558 14.458C24.5558 12.1042 22.693 10.196 20.3951 10.196C18.0972 10.196 16.2344 12.1042 16.2344 14.458C16.2344 16.8118 18.0972 18.7199 20.3951 18.7199Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatusOffline);
export default __webpack_public_path__ + "static/media/ic_status_offline.357b71ac28826cde4585e04fe0be7674.svg";
export { ForwardRef as ReactComponent };